module.exports = __webpack_public_path__ + "img/merit1.f7fc0173.jpg";